<template>
  <UiTabs :value="currentTab.id" :tab-list="tabs" @input="onTabChanged($event)">
    <TableEmpty v-if="!loading && teams.length === 0" style="top: 50%" />
    <PageScroll
      v-else
      class="-width-limiter-"
      :data="teams"
      :is-loading="loading || noMorePage"
      width="100%"
      @incrementPage="incrementPage"
    >
      <Table :nav-titles="localNavTitles">
        <template #nav>
          <NavCell
            v-for="title in localNavTitles"
            :key="title.id"
            :class="{ '-pointer-': title.sortType !== undefined }"
            @click.native="setSort(title)"
          >
            <span>{{ title.title }}</span>
            <Icon
              v-if="title.sortType !== undefined"
              class="ui-space-table__icon -arrow-"
              icon="ui-down"
              :class="{
                '-active-': title.channelId === sortChanel,
                '-rotate-': title.sortType
              }"
            />
            <SlideUpDown
              v-if="title.slider !== undefined && title.slider"
              class="header-desktop-link-list"
              :active="title.slider.open"
              :duration="300"
            >
              <div
                class="silder-text"
                @click="
                  setSort(
                    title,
                    title.slider,
                    title.slider.channelId === 4
                      ? 'profitToOne'
                      : 'revenueToOne'
                  )
                "
              >
                <span>Сортировать по 1 ученику</span>
                <Icon
                  v-if="title.sortType !== undefined"
                  class="ui-space-table__icon -arrow-"
                  icon="ui-down"
                  :class="{
                    '-active-':
                      title.slider.channelId === sortChanel &&
                      (filter.sort.sortName === 'profitToOne' ||
                        filter.sort.sortName === 'revenueToOne'),
                    '-rotate-':
                      (filter.sort.sortName === 'profitToOne' ||
                        filter.sort.sortName === 'revenueToOne') &&
                      filter.sort.sortType
                  }"
                />
              </div>
              <div
                class="silder-text"
                @click="
                  setSort(
                    title,
                    title.slider,
                    title.slider.channelId === 4
                      ? 'profitGrowth'
                      : 'revenueGrowth'
                  )
                "
              >
                <span>Сортировать по процентам</span>
                <Icon
                  v-if="title.sortType !== undefined"
                  class="ui-space-table__icon -arrow-"
                  icon="ui-down"
                  :class="{
                    '-active-':
                      title.slider.channelId === sortChanel &&
                      (filter.sort.sortName === 'profitGrowth' ||
                        filter.sort.sortName === 'revenueGrowth'),
                    '-rotate-':
                      (filter.sort.sortName === 'profitGrowth' ||
                        filter.sort.sortName === 'revenueGrowth') &&
                      filter.sort.sortType
                  }"
                />
              </div>
            </SlideUpDown>
          </NavCell>
        </template>
        <template v-if="loading && !loadMore">
          <Row
            v-for="i in 5"
            :key="`load-${i}`"
            :loading="true"
            :nav-titles="navTitles"
            load-cell-class="-full-border-"
            height="43px"
          />
        </template>
        <template v-else>
          <Spoiler
            v-for="team in teams"
            :key="team.id"
            :nav-titles="navTitles"
            :title="team.name"
            :fillable="team.fillable"
            :revenue-to-one="getFormattedValue(team.revenueToOne)"
            :profit-to-one="getFormattedValue(team.profitToOne)"
            :profit-growth="team.profitGrowth"
            :revenue-growth="team.revenueGrowth"
            @opened="openSpoiler(team)"
            @closed="closeSlider(team)"
          >
            <div v-if="loadingUserValuesTeamId === team.id">
              <div
                v-for="user in team.users"
                :key="user.lmsUserId + 'load'"
                class="ajax__line -round-"
                :style="{ height: '300px', width: '100%', margin: '10px 0' }"
              />
            </div>
            <div v-else-if="activeSpoilers.find(e => e === team.id)">
              <UserCard
                v-for="user in team.users"
                :key="user.lmsUserId"
                :user="user"
                :values="
                  userValues[user.lmsUserId] ? userValues[user.lmsUserId] : []
                "
              />
            </div>
          </Spoiler>
        </template>
        <Row
          v-if="loadMore"
          :key="`load-more`"
          :loading="true"
          :nav-titles="navTitles"
          load-cell-class="-full-border-"
          height="43px"
        />
      </Table>
    </PageScroll>
  </UiTabs>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Table from '../../components/Table';
import Row from '../../components/Table/Row';
import Spoiler from '../../components/Table/Spoiler';
import NavCell from '../../components/Table/NavCell';
import UserCard from './UserCard';
import UiTabs from '@/components/UiKit/Tabs';
import numberFormat from '@/filters/numberFormat.filter';
import SlideUpDown from 'vue-slide-up-down';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: {
    Table,
    Row,
    NavCell,
    Spoiler,
    UserCard,
    UiTabs,
    SlideUpDown
  },
  props: {
    navTitles: {
      type: Array,
      default: () => []
    },
    tabs: {
      type: Array,
      required: true
    },
    currentTab: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    sortChanel: null,
    loadMore: false,
    activeTab: 0,
    activeSpoilers: [],
    isOpen: false,
    localNavTitles: null,
    filter: {
      sort: {
        channelId: null,
        // 0 - DESC; 1 - ASC
        sortType: null,
        sortName: null
      }
    },
    userValues: {},
    loadingUserValuesTeamId: null
  }),
  computed: {
    ...mapState('ratingSpeedAndHundred', {
      teams: s => s.data.teams,
      page: s => s.data.page,
      isLoading: s => s.meta.isLoadingTeams,
      isLoadingPage: s => s.meta.isLoadingPage,
      noMorePage: s => s.meta.noMorePage,
      currentStream: s => s.data.currentStream
    }),
    isAdmin() {
      return this.$store.state['auth'].data.user.permissions.isAdmin;
    },
    loading() {
      return this.isLoading || this.isLoadingPage;
    }
  },
  created() {
    this.localNavTitles = this.navTitles;
    this.initFilter();
  },
  methods: {
    openSpoiler(team) {
      const teamUserIds = team.users.map(user => user.lmsUserId);
      const userIds = [];
      const values = this.userValues;
      teamUserIds.forEach(function (item) {
        if (values.length === 0 || !values[item]) {
          userIds.push(item);
        }
      });
      if (userIds.length) {
        this.loadingUserValuesTeamId = team.id;
        axios
          .get('/traction-analytics/speed-and-hundred/values', {
            params: {
              users: userIds,
              stream: this.currentStream.name
            }
          })
          .then(response => {
            const data = response.data.data;
            for (const [key, item] of Object.entries(data)) {
              this.userValues[key] = item;
            }
          })
          .finally(() => {
            this.loadingUserValuesTeamId = null;
            this.activeSpoilers.push(team.id);
          });
      } else {
        this.activeSpoilers.push(team.id);
      }
    },
    closeSlider(team) {
      this.activeSpoilers.filter(e => e !== team.id);
    },
    initFilter() {
      const query = this.$route.query;
      const filter = this.filter.sort;

      this.filter.sort.channelId =
        parseInt(query['channelId']) || filter.channelId;
      if (query['ascending']) {
        this.filter.sort.sortType = query['ascending'] === 'true' ? 1 : 0;
      } else {
        this.filter.sort.sortType = filter.sortType;
      }
      this.filter.sort.sortName = query['sortBy'] || filter.sortName;

      this.sortChanel = filter.channelId;
      if (filter.channelId > 3) {
        this.changeSort(
          {
            channelId: this.filter.sort.channelId,
            sortType: this.filter.sort.sortType
          },
          filter
        );
      } else {
        this.changeSort({
          channelId: this.filter.sort.channelId,
          sortType: this.filter.sort.sortType
        });
      }
    },
    getFormattedValue(value) {
      return numberFormat(value, this.noDot);
    },
    onTabChanged(tabId) {
      this.$emit('tabChanged', tabId);
    },
    setSort(title, slider = null, name = null) {
      if (title.channelId === undefined && title.sortType === undefined) {
        return;
      }

      if (!slider && title.slider !== undefined && title.slider) {
        title.slider.open = !title.slider.open;
        this.$emit('input', title);
        return;
      }

      let channelId = title.channelId;
      let sortType = title.sortType;
      let sortName = title.sortName;
      if (slider) {
        channelId = slider.channelId;
        sortType = slider.sortType;
        sortName = name;
      }

      if (channelId !== this.filter.sort.channelId) {
        this.changeSort({ channelId }, slider);
      }
      if (
        channelId === this.filter.sort.channelId &&
        sortType === this.filter.sort.sortType
      ) {
        this.filter.sort.sortType = sortType ? 0 : 1;
      } else {
        this.filter.sort.sortType = sortType;
      }
      this.changeSort({ channelId, sortType: sortType ? 0 : 1 }, slider);
      this.filter.sort.sortName = sortName;
      this.sortChanel = channelId;

      const query = [];
      query['sortBy'] = this.filter.sort.sortName;
      query['channelId'] = this.filter.sort.channelId;
      query['ascending'] = this.filter.sort.sortType ? 'true' : 'false';
      this.multipleChangeValue(query);
    },
    changeSort({ channelId, sortType }, slider = null) {
      if (channelId !== undefined) {
        this.filter.sort.channelId = channelId;
      }

      if (channelId !== undefined && sortType !== undefined) {
        if (slider) {
          const idx = this.localNavTitles.findIndex(
            nav => nav.channelId === channelId
          );
          if (idx === -1) {
            return;
          }
          this.localNavTitles[idx].slider = slider;
        } else {
          const idx = this.localNavTitles.findIndex(
            nav => nav.channelId === channelId
          );
          if (idx === -1) {
            return;
          }
          this.localNavTitles[idx].sortType = sortType;
        }
      }
    },
    multipleChangeValue(params) {
      const arrQuery = Object.entries({ ...this.$route.query, ...params }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }

      replaceRouteQuery(arrQuery);
    },
    checkRouterEqual(arrQuery) {
      return !arrQuery.find(
        param => param.value != this.$route.query[param.name]
      );
    },
    async incrementPage() {
      this.loadMore = true;
      await this.$store.dispatch('ratingSpeedAndHundred/setData', {
        path: 'page',
        value: this.page + 1
      });
      await this.$store.dispatch('ratingSpeedAndHundred/getUsersList');
      this.loadMore = false;
    }
  }
};
</script>
